import axios from 'axios'
import { Offer_Promotions } from './backend'

const getOverview = async (site) => {
    const resp = await axios({ 
        method: 'get', 
        url: `https://assets.urlaubsgutschein.kaufen/whitelabel/${site}/a.json`,
        responseType: 'json'})
    return resp.data;
}

const getCurrentPromotions = async () => {
    let { data } =  await Offer_Promotions();
    return data;
}

export default {
    getOverview,
    getCurrentPromotions
}